<template>
    <footer id="footer" class="footer solid-bg">
        <div class="wf-wrap">
            <div class="wf-container-footer">
                <div class="wf-container"> 				
                </div><!-- .wf-container -->
            </div><!-- .wf-container-footer -->
        </div><!-- .wf-wrap -->
    </footer>
</template>

<script setup>

</script>

<style lang="scss" scoped>
footer{
    padding: 0;
    margin: 0;
    grid-area: footer;
    background: #020221 url(@/assets/logobg.jpg) no-repeat  center center;
    background-size: cover; 
    unicode-bidi: isolate;    color: #85868c;
    .wf-wrap{
        width: 1300px;  
        margin: 0 auto;
        max-width: 100%; 
        .wf-container{
            font-size: 0;
            line-height: 0;
            word-spacing: -4px;
            height: 50px;
            color: #85868c;   
            vertical-align: top;
        }
    }
}
 
</style>
